import { Box, Button } from "@mui/material"
import Icon from "@mdi/react"
import { mdiTruck, mdiTools, mdiHelpCircleOutline, mdiCalendarClock } from "@mdi/js"

import useToggle from "@secureo/common/hooks/useToggle"

import ShippingOptions from "./ShippingOptions"

import { makeStyles } from "makeStyles"
import getDeliveryTimeWorkDaysString from "@secureo/common/utils/commerceTools/formatters/getDeliveryTimeWorkDaysString"
import formatPrice from "@secureo/common/utils/forex/formatPrice"
import { flatFeesByCurrencyCode } from "@secureo/common/config/shippingZonesAndCosts"

import {
	DeliveryOption,
	DeliveryOptionsByDestinationCountryCode,
	ShippingOriginationCountryCodesByDestinationCountryCode,
} from "@secureo/common/typings/Product"
import { CountryCode } from "@secureo/common/typings/CountryCode"
import useTranslation from "hooks/useTranslation"
import { CurrencyCode } from "@secureo/common/typings/Forex"

const useStyles = makeStyles()((theme) => ({
	deliveryTime: {
		color: theme.palette.primary.main,
		display: "flex",
		alignItems: "center",
	},
	shippingOverview: {
		// fontSize: "75%",
	},
	montageService: {
		display: "flex",
		alignItems: "center",
	},
}))

const DeliveryCalculation = ({
	deliveryTimeWorkdays,
	isFreeShipping,
	hasAssemblyService,
	deliveryOptions,
	isHaulageDelivery,
	shippingOriginationCountryCodesByDestinationCountryCode,
	weightKg,
	totalPriceOfProduct,
	deliveryOptionsBySku,
	countryCode,
	language,
	currencyCode,
}: Props) => {
	const { classes } = useStyles()
	const [isOpen, toggleIsOpen] = useToggle()
	const { t } = useTranslation("product")

	return (
		<>
			<Box mb={1} className={classes.deliveryTime}>
				<Icon path={mdiCalendarClock} size={0.7} color="#7abfac" />
				<Box ml={1}>
					{t("deliveryTime")}:{" "}
					{getDeliveryTimeWorkDaysString(deliveryTimeWorkdays, language)}
				</Box>
			</Box>
			<>
				<div style={{ display: "flex" }}>
					<Icon
						path={mdiTruck}
						size={0.7}
						style={{ marginRight: "8px", marginTop: "5px" }}
					/>
					<strong>
						{isFreeShipping
							? t("freeDeliveryForThisArticle")
							: `${t("freeDeliveryFrom")} ${formatPrice(
									flatFeesByCurrencyCode[currencyCode]
										.flatFeeForSmallAmountThresholdGrossCents,
									"de-DE",
							  )}`}
					</strong>
				</div>
				<Box my={1}>
					<div className={classes.shippingOverview}>
						<Button
							onClick={toggleIsOpen}
							style={{
								display: "flex",
								padding: 0,
								textDecoration: "underline",
								textTransform: "inherit",
							}}
						>
							<Icon
								path={mdiHelpCircleOutline}
								size={0.7}
								style={{ marginRight: "8px" }}
							/>
							{t("showDeliveryCostOverview")}{" "}
						</Button>
					</div>
				</Box>
			</>

			{hasAssemblyService && (
				<Box className={classes.montageService}>
					<Icon path={mdiTools} size={0.6} />
					<Box ml={1}>{t("assemblyAvailable")}</Box>
				</Box>
			)}

			<ShippingOptions
				isOpen={isOpen}
				toggleIsOpen={toggleIsOpen}
				deliveryOptions={deliveryOptions}
				isHaulageDelivery={isHaulageDelivery}
				shippingOriginationCountryCodesByDestinationCountryCode={
					shippingOriginationCountryCodesByDestinationCountryCode
				}
				deliveryOptionsBySku={deliveryOptionsBySku}
				grossProductPriceEuroCents={totalPriceOfProduct}
				weightKg={weightKg}
				countryCode={countryCode}
				currencyCode={currencyCode}
			/>
		</>
	)
}

interface Props {
	deliveryTimeWorkdays: number
	isFreeShipping: boolean
	hasAssemblyService: boolean
	deliveryOptions: DeliveryOptionsByDestinationCountryCode
	isHaulageDelivery: boolean
	shippingOriginationCountryCodesByDestinationCountryCode: ShippingOriginationCountryCodesByDestinationCountryCode
	weightKg: number
	totalPriceOfProduct: number
	deliveryOptionsBySku: {
		[sku: string]: DeliveryOption
	}
	countryCode: CountryCode
	currencyCode: CurrencyCode
	language: string
}

export default DeliveryCalculation
